export default __webpack_public_path__ + "static/media/Deepiq_chart (2).c5a12150.png";